import { getSearchResultStorage } from '@/helpers/StorageHelper';
import { HgSessionStorageKey } from '@/models';

export function getH3ReachableCells(): string[] | null {
  return getSearchResultStorage().getSessionStorageItem(HgSessionStorageKey.H3_REACHABLE_CELLS);
}
